import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import InsightsIcon from '@mui/icons-material/Insights';
import PreviewIcon from '@mui/icons-material/Preview';
import { DELETE, EDIT, UserListEvent } from '../user-list-events';
import { IconButton, Tooltip } from '@mui/material';
import { DynamicFormDefinition } from 'src/common';
import { useContext } from 'react';
import { DependencyInjectionContext } from '../../../../contexts/dependency-injection-context';

const UserActionList = ({ data, callback, clientId }: {
    data: DynamicFormDefinition,
    callback: (event: UserListEvent, form: DynamicFormDefinition, clientId: string | undefined) => void,
    clientId: string | undefined
}) => {

    const { applicationState } = useContext(DependencyInjectionContext);

    return (
        <span>
            <Tooltip title="Edit">
                <IconButton onClick={() => callback(EDIT, data, applicationState.selectedClientId)}><EditIcon /></IconButton>
            </Tooltip>

            <Tooltip title="Delete">
                <IconButton onClick={() => callback(DELETE, data, applicationState.selectedClientId)}>
                    <DeleteIcon />
                </IconButton>
            </Tooltip>
        </span>
    );
};

export default UserActionList;